/**
 * 重复使用的组件进行全局安装
 */
import PageHeader from './PageHeader.vue'
import FormDialog from './FormDialog.vue'

export default function install(Vue){
  Vue.component(PageHeader.name, PageHeader)
  Vue.component(FormDialog.name, FormDialog)
}